import React from "react";

const STATUS_STYLES = {
  New:                  { bg: "#EBF4FF", color: "#1D6FA4", dot: "#3B9EDF" },
  ReportGenerated:      { bg: "#F3EEFF", color: "#6B3FAB", dot: "#9C6FD6" },
  SentToBank:           { bg: "#FFF4E5", color: "#B45309", dot: "#F59E0B" },
  BankResponseReceived: { bg: "#ECFDF5", color: "#065F46", dot: "#10B981" },
  Archived:             { bg: "#F3F4F6", color: "#6B7280", dot: "#9CA3AF" },
};

const LeadStatusBadge = ({ status, label }) => {
  const s = STATUS_STYLES[status] || STATUS_STYLES.Archived;
  return (
    <span style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 5,
      padding: "3px 10px 3px 7px",
      borderRadius: 20,
      background: s.bg,
      color: s.color,
      fontSize: 12,
      fontWeight: 600,
      lineHeight: "18px",
      whiteSpace: "nowrap",
    }}>
      <span style={{
        width: 7,
        height: 7,
        borderRadius: "50%",
        background: s.dot,
        flexShrink: 0,
      }} />
      {label}
    </span>
  );
};

export default LeadStatusBadge;
